import { Box } from '@mui/material'
import AboutHeroSection from '../components/about/AboutHeroSection'
import FoundersMessageSection from '../components/about/FoundersMessageSection'
import AboutVisionMissionSection from '../components/about/AboutVisionMissionSection'
import AboutDimensionsSection from '../components/about/AboutDimensionsSection'
import AboutTimelineSection from '../components/about/AboutTimelineSection'
import AboutValuesSection from '../components/about/AboutValuesSection'
import MeetOurTeamSection from '../components/about/MeetOurTeamSection'
import { mobilePaddingX } from '../theme/mobileLayout'
import { programSectionGap } from '../components/programs/programLayout'

const sectionWrapperSx = {
  width: '100%',
  maxWidth: 1920,
  mx: 'auto',
  px: mobilePaddingX,
  boxSizing: 'border-box',
}

export default function AboutPage() {
  return (
    <Box>
      <AboutHeroSection />

      <Box sx={{ ...sectionWrapperSx, pb: 0 }}>
        <Box
          sx={{
            maxWidth: 1520,
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '80px', md: 12, lg: '120px' },
          }}
        >
          <FoundersMessageSection />

          <AboutVisionMissionSection />
        </Box>
      </Box>

      <AboutDimensionsSection />

      <AboutTimelineSection />

      <Box sx={{ ...sectionWrapperSx, py: programSectionGap }}>
        <Box sx={{ maxWidth: 1520, mx: 'auto' }}>
          <AboutValuesSection />
        </Box>
      </Box>

      <Box sx={{ ...sectionWrapperSx, pb: programSectionGap }}>
        <Box sx={{ maxWidth: 1520, mx: 'auto' }}>
          <MeetOurTeamSection />
        </Box>
      </Box>
    </Box>
  )
}
